import {injectable} from 'inversify';

import type {TaskModel} from './Task.model';

import {BaseController} from '../Base/Base.controller';

@injectable()
export class TaskController extends BaseController<TaskModel> {
  constructor() {
    super();
  }
}
